import React from 'react';
import PropTypes from 'prop-types';
import { FormInput } from '@ami/react/core';
import { Button } from 'reactstrap';
import { getGenericData, saveGenericData } from '@ami/react/core';
import { withRouter } from 'react-router-dom';
import customerApprovalLookupServices from '../../services/customerApprovalLookupServices';

const filterStorageKey = 'customer-approval-contact-info';

class CustomerApprovalContactInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateEntity = this.updateEntity.bind(this);
  }

  state = {
    fullName: this.initializeFullName(),
  };

  static propTypes = {
    entity: PropTypes.object.isRequired,
    onUpdated: PropTypes.func.isRequired,
  };

  initializeFullName() {
    const saved = getGenericData(filterStorageKey);
    return saved ? saved : '';
  }

  updateEntity(e) {
    this.setState({ fullName: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();
    saveGenericData(filterStorageKey, this.state.fullName);
    this.props.entity.documents.forEach((element) => {
      customerApprovalLookupServices.viewed(
        element.customerApprovalId,
        this.state.fullName
      );
    });
    this.props.onUpdated(this.state.fullName);
  }

  render() {
    const { fullName } = this.state;

    return (
      <div className="card mb-4 box-shadow quote-info">
        <div className="card-body">
          <h6 className="card-title text-center">CONTACT INFORMATION</h6>
          <div className="row justify-content-center p-2">
            <label>
              Before we get started, we need to know a little bit about you in
              case we have questions about the approval.
            </label>
            <FormInput
              placeholder="Please enter your full name"
              id="fullName"
              type="text"
              label=""
              value={fullName}
              onChange={this.updateEntity}
              className="col-sm-6"
              style={{ margin: 'auto' }}
            />
            <Button
              type="button"
              color="primary"
              onClick={this.handleSubmit}
              className="m-1 ms-3"
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(CustomerApprovalContactInfo);
